import { useAuth } from '@/auth/useAuth';

export const useAccessToken = (): string | null => {
  const { session, loading } = useAuth();
  if (loading) {
    return null;
  }
  return session?.tokens.accessToken ?? null;
};
